import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  typography: {
    fontFamily: 'BB-Font-Regular'
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: 'BB-Font-Regular'
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderColor: '#79747E' // Definindo a cor da borda para os inputs
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& input': {
            fontWeight: 'bold'
          }
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            fontWeight: 700
          },
          '&.Mui-selected:hover': {
            backgroundColor: '#eee',
            fontWeight: 700
          },
          '&:hover': {
            backgroundColor: '#eee',
            fontWeight: 700
          },
          '&.Mui-focusVisible': {
            fontWeight: 700
          }
        }
      }
    }
  }
})

export default theme
